import { useMutation } from 'react-query';

import { setKeyActivitiesTags as mutationFn } from 'api/endPoints/setKeyActivitiesTags';

export const useMutationsSetKeyActivitiesTags = () => {
    return useMutation<any, QueryError, unknown>((params) => mutationFn(params));
};
